import React from 'react';

const TeamSection = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Dhiraj Dhumal, M.B.A',
      role: 'Co-Founder @Bitejoy',
      image: '/images/Bitejoy/bitej2.jpeg',
      quote:
        "For me, making chocolates is not just a business—it's a passion. My focus has always been on quality, hygiene, and delivering an authentic taste in every bite. Each chocolate we create reflects our dedication, honesty, and love for the craft, which defines the true identity of our brand.",
      imageStyle: { width: '240px', height: '310px' },
    },
    {
      id: 2,
      name: 'Niraj Joshi, B.voc Media & Communication',
      role: 'Co-Founder @Bitejoy',
      image: '/images/Bitejoy/bitej1.jpeg',
      quote:
        "Chocolate is a small moment of happiness, and that's what inspires me every day. I look after the brand experience, product consistency, and customer satisfaction. I strongly believe that when hygiene, design, and taste come together, the result is a truly memorable chocolate experience.",
      imageStyle: { width: '220px', height: 'auto' },
    },
  ];

  return (
    <div className="container my-5" id="team">
      <section className="text-center" id="opinion">
        <h2 style={{ marginBottom: '30px' }}>Meet Our Team</h2>
        <div className="row mt-4">
          {teamMembers.map((member) => (
            <div key={member.id} className="col-md-6 mb-md-0 mb-4 team-card">
              <img
                className="mb-4 mt-4"
                src={member.image}
                alt={member.name}
                style={{
                  ...member.imageStyle,
                  boxShadow: 'rgb(38, 57, 77) 0px 20px 30px -10px',
                }}
              />
              <h5 className="mb-3">{member.name}</h5>
              <h5 className="mb-3">{member.role}</h5>
              <p>
                <br />
              </p>
              {member.quote}
              <p>
                <br />
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default TeamSection;
